import dynamic from 'next/dynamic';

import { useShouldHideUserAccountExclusiveContent } from '@/hooks/useShouldHideUserAccountExclusiveContent';
import { useListing } from '@/hooks/queries/useListing';

const MediaSection = dynamic(() => import('@/components/property-expose/MediaSection/MediaSection').then((mod) => mod.MediaSection), {
  ssr: false,
});

export const DynamicMediaSection = () => {
  const isUAExclusiveListingAndNotSignedIn = useShouldHideUserAccountExclusiveContent();
  const {
    data: { listing },
  } = useListing();

  if (!listing || (!listing.videoUrlNormalized && !listing.vtourUrlNormalized) || isUAExclusiveListingAndNotSignedIn) return null;

  return <MediaSection listing={listing} />;
};
